import React from "react";
import Feedback from "../../Common/feedback/Feedback";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";

const FeedbackPage = ({ wrapperClass = "" }) => {
  return (
    <ResponsiveContentWrapper className={`content-wrapper ${wrapperClass}`.trim()}>
      <Feedback />
    </ResponsiveContentWrapper>
  );
};

export default FeedbackPage;
